export interface IReturnReceiptDetails {
  billingAddress: IAddress;
  dateOrdered: string;
  unifiedReferenceNumber: string;
  orderId: string;
  orderReturnId: string;
  status: string;
  refundAmount: number;
  payment: IReturnReceiptPayment;
  shipFromAddress: IAddress;
  receiptItems: Array<IReturnReceiptItems>;
  dateRefunded: string;
  shippingRefund: number;
  miscellaneousRefund: string;
  taxRefund: number;
  totalRefund: number;
  refundType: string;
  isShippingReturn: boolean;
  reasonForRefund: string;
  lob: string;
}

export interface IAddress {
  userId: number;
  addressId: string;
  firstName: string;
  lastName: string;
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone: string;
  isShipping: boolean;
  isBilling: boolean;
  isPrimary: boolean;
}

export interface IReturnReceiptItems {
  lineItemId: string;
  productTitle: string;
  productCode: string;
  format: string;
  unitPrice: number;
  language: string;
  quantity: number;
  isShipmentItem: boolean;
  isDigitalItem: boolean;
  refundAmount: number;
  returnedQuantity: number;
  revokedEmailAddresses: Array<string>;
  shipToAddress: IAddress;
  sessionStartDate: string;
  sessionEndDate: string;
  sessionDescription: string;
}

export interface IReturnReceiptPayment {
  paymentType: string;
  paymentMethod: string;
  paymentProcessed: boolean;
  last4DigitsCCNumber: string;
  cardType: string;
}

export default {};
